import { render, staticRenderFns } from "./main-story-slide.vue?vue&type=template&id=0e7b44f8&scoped=true"
import script from "./main-story-slide.vue?vue&type=script&lang=js"
export * from "./main-story-slide.vue?vue&type=script&lang=js"
import style0 from "./main-story-slide.vue?vue&type=style&index=0&id=0e7b44f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7b44f8",
  null
  
)

export default component.exports